"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const SocialLinkedIn = createSVGIcon(
  <path
    d="M6.069 2.931A2.28 2.28 0 0 1 3.84 5.23 2.33 2.33 0 0 1 1.595 2.93 2.297 2.297 0 0 1 3.84.737 2.28 2.28 0 0 1 6.07 2.931ZM1.835 9.31c0-1.32.84-1.115 2.005-1.115S5.83 7.99 5.83 9.31v12.857c0 1.337-.84 1.063-1.989 1.063-1.148 0-2.005.274-2.005-1.063zM9.292 9.309c0-.738.274-1.012.703-1.098.428-.085 1.903 0 2.417 0s.72.84.703 1.475a4.3 4.3 0 0 1 3.84-1.715 5.143 5.143 0 0 1 5.451 5.366v8.777c0 1.337-.823 1.063-1.988 1.063s-1.989.274-1.989-1.063v-6.857a2.468 2.468 0 0 0-2.606-2.674 2.487 2.487 0 0 0-2.537 2.726v6.857c0 1.337-.84 1.063-2.005 1.063s-1.989.274-1.989-1.063z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "SocialLinkedIn",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "+LiwSd",
      defaultMessage: "LinkedIn",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    className: legacyIconCls(),
  })
);
